module.exports = __webpack_public_path__ + "static/media/LGSmartBold__W.a6aa1aa9.ttf";